import axios from "axios";
import { Base_URL } from "../url";

// ===============================================
// CREATE CusVen Contact Person
// ===============================================
export const createCusVenCp = async (payload, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CusVenCpMaster/Create`,
      payload,
      {
        params: { userName },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating CusVen Contact Person!";
  }
};

// ===============================================
// GET ALL CusVen Contact Persons
// ===============================================
export const fetchAllCusVenCp = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CusVenCpMaster/GetAll`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching CusVen Contact Persons!";
  }
};

// ===============================================
// GET CusVen Contact Persons BY ORG ID
// ===============================================
export const fetchCusVenCpByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CusVenCpMaster/GetByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || "Error fetching CusVen Contact Persons by Org!"
    );
  }
};

// ===============================================
// GET CusVen Contact Persons BY CusVenTypeId (Customer Code)
// ===============================================
export const fetchCusVenCpByCusVenType = async (cusVenTypeId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CusVenCpMaster/GetByCusVenType/${cusVenTypeId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching Contact Persons by Customer!";
  }
};

// ===============================================
// GET CusVen Contact Person BY ID
// ===============================================
export const fetchCusVenCpById = async (cusVenId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CusVenCpMaster/GetById/${cusVenId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching CusVen Contact Person!";
  }
};

// ===============================================
// UPDATE CusVen Contact Person
// ===============================================
export const updateCusVenCp = async (payload, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/CusVenCpMaster/Update`,
      payload,
      {
        params: { userName },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating CusVen Contact Person!";
  }
};
